import firebase from 'firebase/app';
import FaraGostarDynamicHttp from './api/FaraGostarDynamicHttp';

// var firebaseConfig = {
//   apiKey: 'AIzaSyCXtw4Ig2zY2Os6diuw8AIa-7hzbaC6SIs',
//   authDomain: 'faragostarnotification.firebaseapp.com',
//   databaseURL: 'https://faragostarnotification.firebaseio.com',
//   projectId: 'faragostarnotification',
//   storageBucket: 'faragostarnotification.appspot.com',
//   messagingSenderId: '453984141811',
//   appId: '1:453984141811:web:b56b046a6f82fdbbb3d286',
// };

export const initializeFirebase = () => {
  // if (firebase.apps.length === 0) {
  //   firebase.initializeApp(firebaseConfig);
  // }
  // try {
  //   const messaging = firebase.messaging();
  //   messaging.onTokenRefresh(function () {
  //     messaging.getToken().then(async (token) => {
  //       await sendData(token);
  //     });
  //   });
  // } catch (error) { }
};

export const askForPermissioToReceiveNotifications = async () => {
  if (!window.config) throw new Error('تنظیمات لاگین یافت نشد');
  if (window.config && !window.config.getNotifications) return;

  // try {
  //   const messaging = firebase.messaging();
  //   await messaging.requestPermission();
  //   const token = await messaging.getToken();
  //   await sendData(token);
  // } catch (error) {
  //   // console.error(error);
  // }
};

async function sendData(token: any) {
  const localStorageToken = localStorage.getItem('firebaseToken');
  if (token && token !== localStorageToken) {
    localStorage.setItem('firebaseToken', token);

    const http = await FaraGostarDynamicHttp();

    await http
      .post('notification/addNotificationToken', {
        token: token,
      })
      .then((response: any) => {
        // ToDo: add token!
        console.log('response', response);
      })
      .catch((error: any) => console.log(error));
  }

  return token;
}
